
import {
  INIT_SIGNOUT,
  SAVE_CHAPTER_LIST,
  SAVE_MODULE_DETAILS,
  SAVE_VIDEO_COMPLETE_STATUS
} from "../Actions/actionTypes";

const INIT_STATE = {
  courseDetails: {},
  moduleDetails: {},
  videoComplete:false
};

const Learning = (state = INIT_STATE, action) => {
  switch (action.type) {
    case SAVE_CHAPTER_LIST:
      return {
        ...state,
        courseDetails: action.courseDetails,
      };
      case SAVE_MODULE_DETAILS:
        return {
          ...state,
          moduleDetails: action.moduleDetails,
        };
      case SAVE_VIDEO_COMPLETE_STATUS:
        return {
            ...state,
            videoCompleteStatus: action.videoStatus,
        };
    case INIT_SIGNOUT:
      return INIT_STATE;

    default:
      return state;
  }
};

export default Learning;
